import { BuyerPaymentCountQuery } from '@gql/BuyerPaymentCountQuery'

type Res = Omit<gen.PaymentInvoiceDocCount, 'id'>

export function useBuyerNotficationCount(): globalThis.Ref<Res> {
  const auth = useAuth()

  const { ui } = useApolloWrap2<gen.BuyerPaymentCountQuery, gen.BuyerPaymentCountQuery>(BuyerPaymentCountQuery)({
    clientId: 'post',
    vars: () => (auth.value.isAuth ? {} : undefined),
    ui: (i): Res => {
      const inp = i?.buyerPaymentInvoiceCount
      return {
        toReview: inp?.toReview || 0,
        payments: inp?.payments || 0,
        quote: inp?.quote || 0,
      }
    },
  })

  return ui
}

export function useBuyerNotficationCountClear(client: ReturnType<typeof useApollo>): void {
  const doc = client.readQuery({ query: TypedDocumentString.getQueryDocument(BuyerPaymentCountQuery) })
  if (!doc) return
  client.cache.evict({ fieldName: 'buyerPaymentInvoiceCount' })
  client.cache.gc()
}
